import React, { useState } from 'react';
import ai2 from '../../assets/img/ai_2.png';

const RecommenderPopUp = (props) => {
  const [isClicked, setIsClicked] = useState(false);
  let iconDimensions = { height: '36px', width: '50px' };

  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  // small
  if (props?.size === 's') {
    iconDimensions = { height: '25px', width: '25px' };
  }

  return (
    <div style={{ position: 'relative', marginLeft: '8px' }}>
      <img src={ai2} alt="AI Logo" style={{ ...iconDimensions, cursor: 'pointer' }} onClick={handleClick} />

      {isClicked && (
        <div
          style={{
            width: '360px',
            height: 'auto',
            maxWidth: '360px',
            backgroundColor: '#DCE7DF',
            position: 'absolute',
            top: '40px',
            left: '0',
            zIndex: '1',
            borderRadius: '0 10px 10px 10px',
            boxShadow: '0 3px 6px rgba(0, 0, 0, 0.16)',
            padding: '25px 20px 0 20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            fontSize: '12px',
          }}
        >
          {props.children}
        </div>
      )}
    </div>
  );
};
export default RecommenderPopUp;
